var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileBuilderOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.781,
    height: 44.781,
    viewBox: "0 0 44.781 44.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55667",
    "data-name": "Path 55667",
    d: "M2,6.8v10.5a4.8,4.8,0,0,0,4.8,4.8h10.5a4.8,4.8,0,0,0,4.8-4.8V6.8a4.8,4.8,0,0,0-4.8-4.8H6.8A4.8,4.8,0,0,0,2,6.8Z",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55668",
    "data-name": "Path 55668",
    d: "M2,32.731a4.8,4.8,0,0,0,4.8,4.8h10.5a4.8,4.8,0,0,0,4.8-4.8v-10.5a4.8,4.8,0,0,0-4.8-4.8H6.8a4.8,4.8,0,0,0-4.8,4.8Z",
    transform: "translate(0 9.252)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55669",
    "data-name": "Path 55669",
    d: "M32.731,17.438h-10.5a4.8,4.8,0,0,0-4.8,4.8v10.5a4.8,4.8,0,0,0,4.8,4.8h10.5a4.8,4.8,0,0,0,4.8-4.8v-10.5A4.8,4.8,0,0,0,32.731,17.438Z",
    transform: "translate(9.252 9.252)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55670",
    "data-name": "Path 55670",
    d: "M35.93,10.446H29.082V3.6a1.6,1.6,0,0,0-3.2,0v6.847H19.037a1.6,1.6,0,0,0,0,3.2h6.847v6.847a1.6,1.6,0,0,0,3.2,0V13.645H35.93a1.6,1.6,0,0,0,0-3.2Z",
    transform: "translate(9.252)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBuilderOthers);
export default __webpack_public_path__ + "static/media/profile-builder-others.c3e0b92576393cc579f22835ac29670d.svg";
export { ForwardRef as ReactComponent };